import ShowShortenedRichText from './ShowShortenedRichText.component';

export default ShowShortenedRichText;